import NextImage from 'next/image';
import React, { ComponentProps, FC } from 'react';

export const Image: FC<ComponentProps<typeof NextImage>> = ({ fill = true, ...props }) => (
  <NextImage fill={fill} quality={100} style={{ objectFit: 'cover' }} {...props} />
);
